import React, { useCallback } from 'react';
import { EventBus } from '@vtblife/event-bus';
import {
    CaptchaChallengePassedEventType,
    CaptchaChallengePassedPayload,
    ShowCaptcha,
    CaptchaChallengeHiddenEventType,
    CaptchaChallengeHiddenPayload,
} from '@vtblife/event-bus-events';
import { useGqlContext } from '@search/gql-client/src';

import {
    OfferPhoneQuery$data as OfferPhoneQueryResponse,
    OfferPhoneQuery$variables as OfferPhoneQueryVariables
} from './__generated__/OfferPhoneQuery.graphql';
import { OfferPhoneQuery } from './OfferPhoneQuery';

export function useOfferPhoneWithCaptcha() {
    const gql = useGqlContext();
    const eventBus = EventBus.getInstance();

    return useCallback((variables: OfferPhoneQueryVariables): Promise<OfferPhoneQueryResponse> => {
        return new Promise((resolve, reject) => {
            const subscriptions = [
                eventBus.subscribe<CaptchaChallengePassedEventType, CaptchaChallengePassedPayload>(
                    'captcha:challenge-passed',
                    ({ data }) => {
                        subscriptions.forEach((s) => s.unsubscribe());
                        try {
                            const response = gql.execute<
                                OfferPhoneQueryVariables,
                                OfferPhoneQueryResponse
                            >(OfferPhoneQuery, variables, { pathUniqSuffix: '/get-offer-phone', extraHeaders: { 'Captcha-Token': data.token } });

                            response.then((res) => {
                                resolve(res.data);
                            });
                        } catch (err) {
                            reject(err);
                        }
                    },
                ),
                eventBus.subscribe<CaptchaChallengeHiddenEventType, CaptchaChallengeHiddenPayload>(
                    'captcha:challenge-hidden',
                    () => {
                        subscriptions.forEach((s) => s.unsubscribe());
                        reject(new Error('Captcha closed'));
                    },
                ),
            ];
            const showCaptchaEvent: ShowCaptcha = {
                type: 'captcha:show',
                category: 'simple',
                data: {
                    // test: true
                },
            };

            eventBus.publish(showCaptchaEvent);
        });
    }, []);
}
